import React from 'react'
import { useParams } from 'react-router-dom'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import ActivitiesDetailsMain from '../Components/Activities/ActivitiesDetailsMain'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import { api } from '../services/api'
import { usePageBanner } from '../hooks/usePageBanner'

function ActivitiesDetails() {
    const { id } = useParams()
    const { title, bgImage } = usePageBanner({
        itemLoader: api.getActivity,
        itemId: id,
        fallbackTitle: 'Activities Details',
    })

    return (
        <>
            <HeaderOne />
            <Breadcrumb title={title} bgImage={bgImage} />
            <ActivitiesDetailsMain />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default ActivitiesDetails
